<template>
  <div
    class="border-b border-gray-200 py-3"
    @click="$emit('toggle')"
    data-aos="fade-up"
    :data-aos-delay="aosDelay"
  >
    <div
      class="flex justify-between w-full text-left font-medium text-gray-800 cursor-pointer"
    >
      <span>{{ question }}</span>
      <span class="text-primary">{{ isOpen ? "−" : "+" }}</span>
    </div>
    <div v-if="isOpen" class="mt-2 text-gray-600 text-sm">
      {{ answer }}
    </div>
  </div>
</template>

<script setup>
// Define props - termasuk isOpen yang dikontrol dari parent
const props = defineProps({
  question: String,
  answer: String,
  isOpen: {
    type: Boolean,
    default: false,
  },
  aosDelay: {
    type: [String, Number],
    default: 0,
  },
});

// Define emits untuk komunikasi ke parent
const emit = defineEmits(["toggle"]);
</script>
